import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openOrderWindow } from '../../../../../store/actions/orders';
import { getEffectiveOrderPayload } from '../../../../../services/utilities/orderUtils';

/**
 * Shared hook for Buy/Sell actions in Stock Discovery widgets.
 * Mirrors the same logic used in InstrumentRow.js in MarketWatch.
 */
const useDiscoveryRowActions = () => {
  const dispatch = useDispatch();
  const { userSettings } = useSelector((state) => state.profile);
  const positionsArray = useSelector((state) => state.portfolio?.arrPositionsUpdateData || []);

  const handleBuy = useCallback((instrument, e) => {
    e?.stopPropagation();
    const payload = getEffectiveOrderPayload(instrument, 'BUY', userSettings, positionsArray);
    console.log('[DiscoveryActions] Buy clicked — instrument:', instrument);
    console.log('[DiscoveryActions] Order payload:', payload);
    dispatch(openOrderWindow(payload));
  }, [dispatch, userSettings, positionsArray]);

  const handleSell = useCallback((instrument, e) => {
    e?.stopPropagation();
    const payload = getEffectiveOrderPayload(instrument, 'SELL', userSettings, positionsArray);
    console.log('[DiscoveryActions] Sell clicked — instrument:', instrument);
    console.log('[DiscoveryActions] Order payload:', payload);
    dispatch(openOrderWindow(payload));
  }, [dispatch, userSettings, positionsArray]);

  return { handleBuy, handleSell, userSettings };
};

export default useDiscoveryRowActions;
